import React from "react";
import Slider from "react-slick";
import { Box, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
  };

  const slides = [
    { img: "../1.jpg", label: "1" },
    { img: "../3.jpg", label: "2" },
    { img: "../4.jpg", label: "3" },
    { img: "../5.jpg", label: "4" },
  ];

  const slideWidth = useBreakpointValue({ base: "100%", md: "60%" });

  return (
    <Box maxW={slideWidth} mx="auto" align="center">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box key={index} p={4}>
            <Image
              src={slide.img}
              alt={slide.label}
              borderRadius="md"
              width="800px" // Set a constant width
              height="450px" // Set a constant height
              objectFit="cover"
            />
            <Text mt={2} fontSize="xl" textAlign="center" color="#333">
              {slide.label}
            </Text>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Carousel;
